export const sellCarDummyData = {
  brands: ["Honda", "Tata", "Jaguar", "Nissan", "BMW", "Volvo"],
  model: [
    {
      name: "i20",
      image:
        "https://imgd.aeplcdn.com/1920x1080/n/cw/ec/150603/i20-exterior-right-front-three-quarter-7.jpeg?isig=0&q=80&q=80",
    },
    {
      name: "Verna",
      image:
        "https://auto.economictimes.indiatimes.com/files/retail_files/verna-1504249732-prod-var.png",
    },
    {
      name: "Creta",
      image:
        "https://imgd.aeplcdn.com/664x374/n/cw/ec/106815/creta-exterior-right-front-three-quarter-5.jpeg?isig=0&q=80",
    },
    {
      name: "Grand i10",
      image:
        "https://stimg.cardekho.com/images/carexteriorimages/930x620/Hyundai/Grand-i10/7715/1585572310544/front-left-side-47.jpg",
    },
  ],
  variants: {
    engine: ["Petrol", "Diesel"],
    transmission: [
      {
        name: "Manual",
        image: "tabler:manual-gearbox",
      },
      {
        name: "Automatic",
        image: "mdi:automatic",
      },
    ],
  },
  carValuation: {
    vehicleInfo: {
      carNumber: "ABC1234",
      brand: "Honda",
      model: "Civic",
      year: "2020",
    },
    specification: {
      fuelType: "Petrol",
      transmission: "Automatic",
      variant: "ZXI",
      km: "15000",
    },
    sellingDetails: {
      sellTimeLine: "Within 1 month",
      phoneNumber: "9876543210",
    },
    estimatePrice: 425000,
  },
};
